export default __webpack_public_path__ + "static/media/aboutus-production@2x.9eb618c0.png";